import { Flex, Text } from '@chakra-ui/react';
import { InventoryDef } from '../../service/inventory';
import { CurrencyIcon } from './CurrencyIcon';

interface PendingItemProps {
    inventoryDef: InventoryDef;
    isOddRow: boolean;
}

export const PendingListItem: React.FC<PendingItemProps> = ({ inventoryDef, isOddRow }) => {
    return (
        <Flex
            className={
                isOddRow
                    ? 'pending-list-item background-row-light'
                    : 'pending-list-item background-row-dark'
            }
        >
            <Text>{inventoryDef.inventory_key.pending?.source}</Text>
            <Text>{inventoryDef.inventory_key.pending?.release_date}</Text>
            <Flex className={'purchase-align'}>
                <CurrencyIcon itemID={inventoryDef.inventory_item.item_id} />
                <Text>{inventoryDef.quantity}</Text>
            </Flex>
        </Flex>
    );
};
